/** * Created by vouill on 11/13/17. */

<template>
  <div :class="'navigation ' + color">
    <ul>
      <li>
        <router-link class="brand" to="/">
          <strong>LOKEO</strong>
        </router-link>
      </li>
    </ul>
    <ul>
      <li v-if="isProfileLoaded">
        <router-link to="/account">{{ getProfile.name }}</router-link>
      </li>
      <li v-if="isAuthenticated" @click="logout">
        <span class="logout">Logout</span>
      </li>
      <li v-if="!isAuthenticated && !authLoading">
        <router-link to="/login">Login</router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
  name: "navigation",
  props: {
    color: {
      type: String,
      default: "green"
    }
  },
  methods: {
    logout: function() {
      this.$store.dispatch("auth/authLogout");
    }
  },
  computed: {
    ...mapGetters("auth", ["isAuthenticated"]),
    ...mapGetters("user", ["getProfile", "isProfileLoaded"]),
    ...mapState({
      authLoading: state => state.auth.status === "loading"
    })
  }
};
</script>

<style lang="scss" scoped>
a {
  color: white;
  text-decoration: none;
}
.navigation {
  display: flex;
  color: #31475e;
  align-items: center;
  padding: 35px 35px 35px 100px;
  &.green {
    background-color: #46bd87;
  }

  &.red {
    background-color: #bd4650;
  }

  ul {
    display: flex;
    &:first-child {
      flex-grow: 1;
    }
    li {
      padding-right: 1em;
    }
  }
}
.brand {
  display: flex;
  align-items: center;
}
.logout {
  &:hover {
    cursor: pointer;
  }
}
</style>
